import { take } from 'rxjs';

import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, computed, inject, input, output } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';

import { ApmTranslatePipe } from '@mitsubishi/core';
import { StatisticOption } from '@mitsubishi/project/data-access';
import { DialogService } from '@mitsubishi/ui/dialog';

import { FaIconComponent } from '@fortawesome/angular-fontawesome';

import { StatisticDataDialogComponent } from '../statistic-data-dialog/statistic-data-dialog.component';

export interface StatisticGroup {
  groupCode: string;
  statistics: Record<string, StatisticOption>;
  resourceId: number;
  displayOrder: number;
}

@Component({
  selector: 'apm-statistics-data-icons',
  templateUrl: './statistics-data-icons.component.html',
  styleUrls: ['./statistics-data-icons.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, FaIconComponent, MatTooltip, ApmTranslatePipe],
})
export class StatisticsDataIconsComponent {
  #dialogService = inject(DialogService);
  disabled = input<boolean>(false);
  statisticData = input<{ [key: string]: StatisticGroup } | null>();

  statisticClick = output<void>();

  statisticDataIcons = computed(() => {
    const statisticData = this.statisticData();
    if (!statisticData) {
      return [];
    }

    return Object.keys(statisticData)
      .flatMap(key => {
        const group = statisticData[key];
        return Object.values(group.statistics).map((stat: any) => ({
          icon: stat.icon,
          resourceId: stat.resourceId,
          statisticCode: stat.statisticCode,
          groupCode: group.groupCode,
          displayOrder: group.displayOrder,
        }));
      })
      .sort((a, b) => a.displayOrder - b.displayOrder);
  });

  projectId?: string;
  selectionId?: string;

  onStatisticClick(): void {
    if (this.disabled()) {
      return;
    }
    this.#dialogService
      .openDialog(StatisticDataDialogComponent, 'xl', this.statisticData())
      .afterClosed()
      .pipe(take(1))
      .subscribe();
  }
}
